/* eslint-disable no-shadow */

import Vue from 'vue';
import GitHub from '../../api/github';
import Events from '../../services/events.service';
import Notifications from '../../services/notification.service';

// initial state
const state = {
  changeMap: {}
};

// getters - all receive state as first argument
const getters = {
  getChangeMap: (state) => state.changeMap
};

// actions
const actions = {
  async getChangeMap({commit}) {
    const changeMap = await GitHub.changeMap();
    commit('setChangeMap', changeMap);
  },
  async gitChangeBranch({commit, dispatch}, {branch, reload}) {
    if (branch === this.branch) return;
    try {
      // change branch gets a new changeMap for new branch and a new user with new token
      const {user, changeMap, exists} = await GitHub.changeBranch(branch);

      // stop listening on any existing channels to be safe
      // 8/26/2020 - I don't think we can do this because we're listening on a bus for the local CLI and such and that won't get reloaded
      // await Messages.teardown();
      if (!exists) Notifications.alert(`Git branch <strong>${branch}</strong> does not exist. Please create this branch in GitHub.`);

      // use the other user.js module in vuex to set the user which also sets the localstore one
      await dispatch('setUser', {...user, gitBranchExists: exists});

      // set our changeMap to the new one for this new branch
      commit('setChangeMap', changeMap);

      // Tell PubNub (gitBus.service.js) to update its channel)
      Events.$emit('gitBranchChanged');

      // optionally reset the router so all componenets reload
      if (reload) commit('reloadRouter'); // In case we're on a page loaded using the gitBranch
    } catch (error) {
      console.error('Error changing branches:');
      console.error(error);
    }
  }
};

// mutations
const mutations = {
  setChangeMap(state, changeMap) {
    state.changeMap = changeMap;
  },
  addToGitMap(state, item) {
    if (item.guid in state.changeMap) return;
    Vue.set(state.changeMap, item.guid, item);
  },
  removeToGitMap(state, item) {
    if (!(item.guid in state.changeMap)) return;
    Vue.delete(state.changeMap, item.guid);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
